import {
  CollectionStreamPostFragmentFragment,
  StreamPostCardFragmentFragment,
} from '../__generated__/graphql';
import { StreamPostCard } from './stream-post-card/stream-post-card';

export const PolymorphicPostCard = ({
  post,
  linkToPost,
}: {
  post: StreamPostCardFragmentFragment | CollectionStreamPostFragmentFragment;
  linkToPost?: boolean;
}) => <StreamPostCard streamPost={post} linkToPost={linkToPost} />;
